export const PERFORMANCE_TYPE_KEYS = {
  SINGLE: 'SINGLE',
  BEST_OF: 'BEST_OF',
  WORST_OF: 'WORST_OF',
  BASKET: 'BASKET',
};

export const PERFORMANCE_TYPES = [
  { id: PERFORMANCE_TYPE_KEYS.SINGLE, displayValue: 'Single' },
  { id: PERFORMANCE_TYPE_KEYS.BEST_OF, displayValue: 'Best Of' },
  { id: PERFORMANCE_TYPE_KEYS.WORST_OF, displayValue: 'Worst Of' },
  { id: PERFORMANCE_TYPE_KEYS.BASKET, displayValue: 'Basket' },
];
